export const LogoMark = ({ className = "h-9" }) => (
  <img
    src="/saivu-logo.png"
    alt="SAIVU logo"
    className={`${className} w-auto object-contain`}
  />
);

export default function Logo({ light = false, compact = false }) {
  return (
    <img
      src="/saivu-logo.png"
      alt="SAIVU — Saivu Consulting Pvt Ltd"
      className="h-11 w-auto object-contain sm:h-12"
      data-testid="brand-logo"
    />
  );
}
